import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchShoutBoxMessage = async (account_id, location_id, last_fetch_id) => {

  try {
    const fetchId = last_fetch_id ? `&last_fetch_id=${last_fetch_id}` : "";
    
    const response = await axios.get(
      `${Config.apiServerUrl}/shout-box?account_id=${account_id}&location_id=${location_id}${fetchId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const addNewMessage = async (formData) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/shout-box/create-message`, 
      formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) { }
};

export const updateShoutboxMessage = (data) => {
  try {
    const response = axios.put(`${Config.apiServerUrl}/shout-box/update-message`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) { }
};
